import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "./certificatesTour.css";

export function startCertificatesPageTour() {
  const steps = [
    {
      popover: {
        title: "Hướng dẫn nhanh",
        description:
          "Tour giới thiệu các khu vực chính của trang Chứng nhận: điều hướng tab, lọc dữ liệu và danh sách phát hành/yêu cầu.",
        side: "over",
        align: "center",
      },
    },
  ];

  const segments = [
    {
      selector: '[data-tour="certificates-header"]',
      title: "Tiêu đề trang",
      description: "Nơi hiển thị thông tin tổng quan của module chứng nhận.",
      side: "bottom",
    },
    {
      selector: '[data-tour="certificates-header-guides"]',
      title: "Cụm nút hướng dẫn",
      description: "Mở nhanh tour trang hoặc tài liệu hướng dẫn HTML.",
      side: "left",
    },
    {
      selector: '[data-tour="certificates-tabs"]',
      title: "Điều hướng theo tab",
      description: "Chuyển giữa danh sách chứng nhận đã cấp và hàng chờ yêu cầu cấp.",
      side: "bottom",
    },
    {
      selector: '[data-tour="certificates-filter"]',
      title: "Bộ lọc & toolbar",
      description: "Tìm kiếm, lọc nâng cao và mở thao tác phát hành/chọn mẫu chứng nhận.",
      side: "bottom",
    },
    {
      selector: '[data-tour="certificates-table"]',
      title: "Danh sách đã cấp",
      description: "Theo dõi chứng nhận, xem preview và tải xuống bản phát hành.",
      side: "top",
    },
    {
      selector: '[data-tour="certificates-requests"]',
      title: "Hàng chờ yêu cầu",
      description: "Xử lý các yêu cầu cấp chứng nhận trong tab Yêu cầu.",
      side: "top",
    },
  ];

  for (const seg of segments) {
    const el = document.querySelector(seg.selector);
    if (!el) continue;
    steps.push({
      element: el,
      popover: {
        title: seg.title,
        description: seg.description,
        side: seg.side,
      },
    });
  }

  if (steps.length <= 1) {
    window.alert("Không tìm thấy vùng để chạy hướng dẫn. Hãy tải lại trang và thử lại.");
    return;
  }

  const d = driver({
    showProgress: true,
    smoothScroll: true,
    stagePadding: 10,
    stageRadius: 14,
    overlayOpacity: 0.68,
    overlayColor: "#0f172a",
    popoverClass: "certificates-tour-popover",
    nextBtnText: "Tiếp",
    prevBtnText: "Trước",
    doneBtnText: "Xong",
    progressText: "Bước {{current}} / {{total}}",
    showButtons: ["next", "previous", "close"],
    steps,
  });

  d.drive();
}
